// This is a fix to ensure no grid gaps on mobile when the promotion cards expand to 2 widths.
// When given an odd number position, it was causing some rows to be left with 1 card and 1 gap.
// This recalculates the order value of the cards in the grid to ensure they fill gaps correctly.
// Responsive grid order fix for mobile: fills gaps caused by 2-col promotion cards
function mobileGridOrder() {
  const mobile_breakpoint = 989;
  if (window.innerWidth >= mobile_breakpoint) {
    // console.log("[GridOrderFix] Not mobile, restoring original order.");
    const grid = document.querySelector(".card-grid");
    if (!grid) return;
    const cards = Array.from(grid.children);
    cards.forEach((card) => {
      const originalOrder = card.getAttribute("data-order");
      if (originalOrder) {
        card.style.order = originalOrder;
      }
    });
    return;
  }
  const grid = document.querySelector(".card-grid");
  if (!grid) {
    return;
  }
  // Collect all cards and their original order
  const cards = Array.from(grid.children);
  // console.log("[GridOrderFix] Found", cards.length, "cards.");
  const cardData = cards.map((card) => ({
    card: card,
    isPromo: card.classList.contains("promotion-card"),
    isProduct: card.classList.contains("product_card"),
    originalOrder: parseInt(card.style.order, 10) || 0,
  }));

  // Sort by original order
  cardData.sort((a, b) => a.originalOrder - b.originalOrder);

  // Build a new array for the mobile grid, filling gaps before every promotion card
  // Ensures each promotion card is sorted in order, since one moving will impact those further down
  const mobileGrid = [];
  let remaining = cardData.slice();
  let productCount = 0;
  while (remaining.length > 0) {
    const card = remaining[0];
    if (card.isPromo) {
      // console.log(
      //   `[GridOrderFix] Promotion card encountered. Product count since last promo:`,
      //   productCount
      // );
      // If odd number of product cards before this promo, move next product card up to fill gap
      if (productCount % 2 === 1) {
        let nextProductIdx = remaining.findIndex(
          (c, idx) => idx > 0 && c.isProduct
        );
        if (nextProductIdx !== -1) {
          const moved = remaining.splice(nextProductIdx, 1)[0];
          mobileGrid.push(moved);
          // console.log(
          //   `[GridOrderFix] Moved product card up to fill gap before promo:`,
          //   moved.el
          // );
        }
      }
      // Place the promo card
      mobileGrid.push(remaining.shift());
      productCount = 0; // reset after promo
      continue;
    }
    // Place product card
    mobileGrid.push(remaining.shift());
    productCount++;
  }

  // Assign new order values
  for (let orderIndex = 0; orderIndex < mobileGrid.length; orderIndex++) {
    mobileGrid[orderIndex].card.style.order = orderIndex + 1;
  }
}

window.addEventListener("DOMContentLoaded", mobileGridOrder);
window.addEventListener("resize", () => {
  clearTimeout(window._cardGridOrderTimeout);
  window._cardGridOrderTimeout = setTimeout(mobileGridOrder, 100);
});
